define("shared/utils/constants", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.CaptionWriterTone = _exports.ActionSeverity = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  let ActionSeverity = _exports.ActionSeverity = /*#__PURE__*/function (ActionSeverity) {
    ActionSeverity["Danger"] = "danger";
    ActionSeverity["Warning"] = "warning";
    ActionSeverity["Info"] = "info";
    return ActionSeverity;
  }({});
  let CaptionWriterTone = _exports.CaptionWriterTone = /*#__PURE__*/function (CaptionWriterTone) {
    CaptionWriterTone["Casual"] = "casual";
    CaptionWriterTone["Professional"] = "professional";
    CaptionWriterTone["Custom"] = "custom";
    return CaptionWriterTone;
  }({});
});